module.exports = "/_next/static/images/icon-192-c5d9b9bb6430f5bfa97be3a074c4efde.png";